import { render, staticRenderFns } from "./receipt_email_toggle.schema.vue?vue&type=template&id=4e181fc6&"
import script from "./receipt_email_toggle.schema.vue?vue&type=script&lang=js&"
export * from "./receipt_email_toggle.schema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports